import { interpolateRgbBasis } from 'd3-interpolate';

export const baseColour = '#D9DBE9'; // @border-gray
export const baseDarkColour = '#707893'; // @text-gray
export const accentColour = '#363B4D'; // @brand-primary
export const infoColour = '#5bc0de'; // @brand-info

export const rainbowBaseColors = [
    "rgb(29, 78, 216)",
    "rgb(109, 40, 217)",
    "rgb(14, 116, 144)",
    "rgb(162, 28, 175)",
    "rgb(4, 120, 87)",
    "rgb(190, 18, 60)",
    "rgb(77, 124, 15)",
    "rgb(180, 83, 9)",

    "rgb(59, 130, 246)",
    "rgb(139, 92, 246)",
    "rgb(6, 182, 212)",
    "rgb(217, 70, 239)",
    "rgb(16, 185, 129)",
    "rgb(244, 63, 94)",
    "rgb(132, 204, 22)",
    "rgb(245, 158, 11)",

    "rgb(3, 105, 161)",
    "rgb(67, 56, 202)",
    "rgb(15, 118, 110)",
    "rgb(126, 34, 206)",
    "rgb(21, 128, 61)",
    "rgb(190, 24, 93)",
    "rgb(161, 98, 7)",
    "rgb(194, 65, 12)",

    "rgb(14, 165, 233)",
    "rgb(99, 102, 241)",
    "rgb(20, 184, 166)",
    "rgb(168, 85, 247)",
    "rgb(34, 197, 94)",
    "rgb(236, 72, 153)",
    "rgb(234, 179, 8)",
    "rgb(249, 115, 22)"
]

const rainbowColorInterpolationGroups = [
    ['rgb(244, 63, 94)', 'rgba(190, 18, 60, 1)'],
    ['rgb(217, 70, 239)', 'rgb(162, 28, 175)'],
    ['rgb(139, 92, 246)', 'rgb(139, 92, 246)'],
    ['rgb(59, 130, 246)', 'rgb(29, 78, 216)'],
    ['rgb(6, 182, 212)', 'rgb(14, 116, 144)'],
    ['rgb(16, 185, 129)', 'rgb(4, 120, 87)'],
    ['rgb(132, 204, 22)', 'rgb(77, 124, 15)'],
    ['rgb(245, 158, 11)', 'rgb(180, 83, 9)'],
    ['rgb(236, 72, 153)', 'rgb(190, 24, 93)'],
    ['rgb(168, 85, 247)', 'rgb(126, 34, 206)'],
    ['rgb(99, 102, 241)', 'rgb(67, 56, 202)'],
    ['rgb(14, 165, 233)', 'rgb(3, 105, 161)'],
    ['rgb(20, 184, 166)', 'rgb(15, 118, 110)'],
    ['rgb(34, 197, 94)', 'rgb(21, 128, 61)'],
    ['rgb(234, 179, 8)', 'rgb(161, 98, 7)'],
    ['rgb(249, 115, 22)', 'rgb(194, 65, 12)']
]


export function rainbowPalette(numberOfColors) {
    // If number of colors requested is equal or less than amount of predefined colors => return predefined colors
    if (numberOfColors <= rainbowBaseColors.length) {
        return rainbowBaseColors.slice(0, numberOfColors);
    }

    // Add predefined colors to palette
    let palette = [...rainbowBaseColors];

    const colorsToGenerate = numberOfColors - rainbowBaseColors.length;
    const numberOfInterpolationGroups = rainbowColorInterpolationGroups.length;
    const interpolationGroupsDivider = Math.floor(colorsToGenerate / numberOfInterpolationGroups) + 2;

    const checkForInterpolationStepIncrease = colorsToGenerate > numberOfInterpolationGroups && colorsToGenerate % numberOfInterpolationGroups > 0;
    const numberOfOverflowColors = colorsToGenerate % numberOfInterpolationGroups;

    // Generate colors between predefined colors
    for (let i = 0; i < colorsToGenerate; i++) {
        const interpolationGroupIndex = i % numberOfInterpolationGroups;
        const [startColor, endColor] = rainbowColorInterpolationGroups[interpolationGroupIndex];
        const colorInterpolator = interpolateRgbBasis([startColor, endColor]);

        let interpolationStep = 1 / interpolationGroupsDivider;

        // Increase interpolation step for colors, which interpolation group is not used in last round
        if (checkForInterpolationStepIncrease) {
            let currentColorOverflowIndex = (i + 1) % numberOfInterpolationGroups;

            if (currentColorOverflowIndex === 0 || currentColorOverflowIndex > numberOfOverflowColors) {
                interpolationStep = 1 / (interpolationGroupsDivider - 1);
            }
        }

        // Value in range of 0 to 1.
        //  - if colorsToGenerate is less than numberOfInterpolationGroups => value is 0.5
        //  - if colorsToGenerate is between numberOfInterpolationGroups + 1 and numberOfInterpolationGroups * 2 => value for i < numberOfInterpolationGroups is 0.33, but for i >= numberOfInterpolationGroups is 0.66
        //  - same incrementation logic with resulting values 0.25, 0.5, 0.75 ; after that 0.2, 0.4, 0.6, 0.8 ; etc.
        const interpolationValue = interpolationStep * (Math.floor(i / numberOfInterpolationGroups) + 1);

        const color = colorInterpolator(interpolationValue);
        palette.push(color);
    }

    return palette;
}
